<template>
  <div class="section">
    <div class="container-fluid">
      <div class="text-left">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/panel/portfolio'}">{{$t(`${title}.title`)}}</el-breadcrumb-item>
            <el-breadcrumb-item>Inversión</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <br><br>
      <div class="row">
        <div class="col-md-3 col-lg-3 text-left">
          <h5>Estatus</h5>
          <el-timeline>
            <el-timeline-item
              v-for="(historic, index) in stages_historic"
              :key="index"
              :type="historic.type"
              :timestamp="historic.created_at"
              placement="top"
              >
              <el-tag size="small" effect="dark" :type="historic.css_class"><strong>{{historic.status}}</strong></el-tag>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="col-md-7 col-lg-7">
          <el-card class="text-left box-card" accordion>
            <el-collapse v-model="activeNames">
              
              <el-collapse-item name="1">
                <template slot="title">
                  <h5> <strong>Detalle de Inversión</strong> </h5>
                </template>
                <div class="text-left pl-4">
                  <strong>Proyecto</strong>
                  <p>{{formData.project}}</p>

                  <strong>Inversor</strong>
                  <p>{{formData.inversor}}</p>
                  <!-- <p>{{formData.inversor_email}}</p> -->

                  <strong>Monto de Inversión</strong>
                  <p>${{formData.invest_ammount}}</p>

                  <strong>Solicitado</strong>
                  <p class="time"> {{formData.date}}</p>

                  <strong>Autorizado</strong>
                  <p class="time"> {{formData.confirmed || "Sin autorizar" }}</p>
                  <!--
                  Última actualización: <span class="time"> {{formData.updated}} </span> <br>
                  -->
                </div>
              </el-collapse-item>

              <el-collapse-item name="2">
                <template slot="title">
                  <h5> <strong>Documentos</strong> </h5>
                </template>
                <div class="text-center pl-4">
                  <documents-form 
                    :investId="this.$route.params.id" 
                    >
                  </documents-form>
                </div>
              </el-collapse-item>

              <el-collapse-item name="3" v-roles="['user']">
                <template slot="title">
                  <h5> <strong>Referencia de pago</strong> </h5>
                </template>
                <div class="text-center pl-4">
                  <reference-payment-form 
                      v-roles="['user']"
                      v-if="showButtonReference"
                      :investId="this.$route.params.id" 
                      :ammount="formData.invest_ammount" 
                      @changed="handleChanged"> 
                  </reference-payment-form>
                </div>
              </el-collapse-item>

              

            </el-collapse>
          </el-card>
        </div>
        <div class="col-md-2 col-lg-2 text-center">
          <h5>Acción</h5>
          <div class="text-center" v-permission="['AUTHORIZE_INVESTMENT']">
            <el-button 
            v-roles="['admin', 'owner']"
            v-if="showButtonDocuments" 
            @click="handleAuthorize()" 
            class="btn btn-info">Autorizar Inversión</el-button>
          </div>
          <div v-roles="['user']">
            <el-button 
            v-if="showButtonNotify" 
            @click="handleNotify()" 
            class="btn btn-info"
            >Notificar Pago</el-button>
          </div>
          <div class="text-center" v-permission="['CONFIRM_PAYMENT']">
            <el-button 
            v-if="showButtonConfirmPayment" 
            @click="handleConfirmPayment()" 
            class="btn btn-info"
            >Confirmar Pago</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FormGroupInput, Alert, Switch, Checkbox, Pagination } from '@/components';
import { Card, DatePicker, Breadcrumb, BreadcrumbItem, Divider, Input,
Upload, Button, MessageBox, Message, Select, Option, Collapse, CollapseItem, Tag,
Timeline, TimelineItem } from 'element-ui';
import ThemifyIcon from "vue-themify-icons"
import _ from "lodash"
import ReferencePaymentForm from '../../pages/components/ReferencePaymentForm';
import DocumentsForm from '../../pages/components/DocumentsForm';

import Investments from '@/providers/Investments'
const provider = new Investments()

import Settings from '@/providers/Settings'
const providerSettings = new Settings()

export default {
  name: 'invest',
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Checkbox.name]: Checkbox,  
    [Switch.name]: Switch,
    Alert,
    [Input.name]: Input,
    [DatePicker.name]: DatePicker,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    [Upload.name]: Upload,
    [Pagination.name]: Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tag.name]: Tag,
    [Timeline.name]: Timeline,
    [TimelineItem.name]: TimelineItem,
    ReferencePaymentForm,
    DocumentsForm
  },
  data() {
    return {
      investId: undefined,
      title: (this.$store.state && this.$store.state.user.role) ? (this.$store.state.user.role == 'USER' ? 'investment' : 'portfolio') : 'investment',
      showButtonReference: false,
      showButtonNotify: false,
      showButtonConfirmPayment: false,
      showButtonDocuments: false,
      formData: {
        project: null,
        inversor: null,
        inversor_email: null,
        invest_ammount: 0,
        project_id: null,
        date: null,
        updated: null,
        confirmed: null
      },
      formProject: {
        id: null,
        name: null,
        start_at: null,
        end_at: null,
        ammount_total: null,
        ammount_recauded_percentage: null,
        summary: null,
        stage_id: null,
        thumbnails: null
      },
      stages_historic: [],
      loading: false,
      stageColors: [
          '',
          '',
          '',
          '',
          'success',
          '',
          '',
          'success',
          '',
          '',
          'danger',
          'sucess'
      ],
      activeNames: ['1'],
      documents: [],
      tableDocuments: []
    }
  },
  mounted() {
    this.investId = this.$route.params.id
    if (this.$store.state.user) {
      if (this.$route.params.id) {
        this.getInvest()
      } else {
        this.$router.push({name: 'portfolio'})
      }
    }else {
      this.$router.push({name: 'index'})
    }    
  },
  methods: {
    getInvest() {
      if (this.$route.params.id) {
        let id = this.$route.params.id
        provider.getById(id).then((response) => {
          let data = response.data.data.attributes
          if(data) {
            this.formData.project = data.project_name
            this.formData.inversor = data.inversor
            this.formData.inversor_email = data.inversor_email
            this.formData.invest_ammount = data.ammount_investment
            this.formData.date = data.registered_at
            this.formData.updated = data.updated_at
            this.formData.confirmed = data.confirmed_at
            this.formData.status_id = data.status_id
            this.formData.status = data.status
            
            this.setButtonsDisabled()
            
            if (data.status_id == 4) {
              this.showButtonDocuments = true
            }
            if (data.status_id == 5) {
              this.showButtonReference = true
            }
            if (data.status_id == 6) {
              this.showButtonNotify = true
              this.showButtonReference = true
            }
            if (data.status_id == 7) {
              this.showButtonConfirmPayment = true
              this.showButtonReference = true
            }
            
            this.getProject(data.project_id)
            this.stages_historic = data.historic
          }
        }).catch((err) => {
          console.info('error get project request')
          console.info(err)
        })
      }
    },
    setButtonsDisabled() {
      this.showButtonAuthorize = false
      this.showButtonReference = false
      this.showButtonNotify = false
      this.showButtonConfirmPayment = false
      this.showButtonDocuments = false
    },
    getProject(id) {
      if (id) {
        provider.getInvestmentPublic(id).then((response) => {
          let data = response.data.data
          if(data && data.attributes) {
            this.formProject.id = data.id
            this.formProject.name = data.attributes.name
            this.formProject.start_at = data.attributes.start_at
            this.formProject.end_at = data.attributes.end_at
            this.formProject.ammount_total = data.attributes.ammount_total
            this.formProject.ammount_recauded_percentage = data.attributes.ammount_recauded_percentage
            this.formProject.summary = data.attributes.summary
            this.formProject.stage_id = data.attributes.stage_id
            this.formProject.thumbnails = data.attributes.thumbnails
          }
        }).catch((err) => {
          console.info('error get project request')
          console.info(err)
        })
      }
    },
    getStageColor(id){
        return this.stageColors[id - 1]
    },
    handleAuthorize() {
      MessageBox.confirm('Esto autorizará la inversión y se notificará al inversor.',
      "¿Autorizar inversión?",
      {
          confirmButtonText: "Si",
          cancelButtonText: "Cancelar",
          type: "warning"
      }).then(() => {
          this.loading = true
          let id = this.$route.params.id
          provider.authorize(id).then((response) => {
              Message({ type: 'success', message: 'Inversión autorizada', effect: "dark" })
              this.getInvest()
          }).catch((err) => {
              console.info(err)
              Message({ type: 'error', message: 'Error al autorizar', effect: "dark" })
              this.loading = false
          })
      }).catch(()=>{
          this.loading = false
      })
    },
    handleNotify() {
      MessageBox.confirm('Esto indica que has realizado el pago correspondiente',
        "¿Notificar Pago?",
        {
            confirmButtonText: "Si",
            cancelButtonText: "Cancelar",
            type: "warning"
        }).then(() => {
            this.loading = true
            provider.notifyPayment({id: this.investId}).then((resp)=> {
              this.showButtonNotify = false
              this.loading = false
              Message({ type: 'success', message: 'Tu pago se ha notificado, en cuanto se valide serás notificado por correo electrónico', effect: "dark" })
              this.getInvest()
            }).catch((err)=>{
              Message({ type: 'error', message: 'Datos incorrectos' })
              this.loading = false
            })
        }).catch(()=>{
            this.loading = false
        })
    },
    handleConfirmPayment() {
      MessageBox.confirm('Al autorizar un pago se modifica el porcentaje de inversión recaudado',
        "¿Confirmar Pago?",
        {
            confirmButtonText: "Si",
            cancelButtonText: "Cancelar",
            type: "warning"
        }).then(() => {
            this.loading = true
            provider.confirmPayment({id: this.investId}).then((resp)=> {
              this.showButtonConfirmPayment = false
              this.loading = false
              Message({ type: 'success', message: 'Pago confirmado', effect: "dark" })
              this.getInvest()
            }).catch((err)=>{
              Message({ type: 'error', message: 'Datos incorrectos' })
              this.loading = false
            })
        }).catch(()=>{
            this.loading = false
        })
    },
    handleChanged () {
      this.getInvest()
    }
  }
};
</script>
<style scope>
  .time {
    font-size: 16px;
    font-weight: 500;
    color: #999;
  }
</style>
